
import { SutraSegment } from './types';

export const HEART_SUTRA: SutraSegment[] = [
  {
    id: 0,
    text: "观自在菩萨，行深般若波罗蜜多时，照见五蕴皆空，度一切苦厄。",
    meaning: "观世音菩萨在修行深奥的智慧时，洞察到五种感官与意识的集合体本质上是空的，从而超脱了一切痛苦与灾难。",
    visualPrompt: "",
    imageUrl: "https://api.aifuture.net.cn/zenheart/images/0"
  },
  {
    id: 1,
    text: "舍利子，色不异空，空不异色，色即是空，空即是色。",
    meaning: "舍利子啊，物质世界（色）与虚空本质没有区别，虚空也不离开物质。物质就是虚空，虚空就是物质。",
    visualPrompt: "",
    imageUrl: "https://api.aifuture.net.cn/zenheart/images/1"
  },
  {
    id: 2,
    text: "受想行识，亦复如是。",
    meaning: "我们的感受、思想、意志和意识，也同样都是这种虚空的本质。",
    visualPrompt: "",
    imageUrl: "https://api.aifuture.net.cn/zenheart/images/2"
  },
  {
    id: 3,
    text: "舍利子，是诸法空相，不生不灭，不垢不净，不增不减。",
    meaning: "舍利子，万法的本质是虚空的，没有生起也没有灭亡，没有污垢也没有洁净，没有增加也没有减少。",
    visualPrompt: "",
    imageUrl: "https://api.aifuture.net.cn/zenheart/images/3"
  },
  {
    id: 4,
    text: "是故空中无色，无受想行识，无眼耳鼻舌身意，无色声香味触法。",
    meaning: "所以在虚空的境界中，没有物质、感受、思想、意志和意识；没有视觉、听觉、嗅觉、味觉、触觉和思维。",
    visualPrompt: "",
    imageUrl: "https://api.aifuture.net.cn/zenheart/images/4"
  },
  {
    id: 5,
    text: "无眼界，乃至无意识界。",
    meaning: "没有视觉的感官世界，乃至没有意识的世界。",
    visualPrompt: "",
    imageUrl: "https://api.aifuture.net.cn/zenheart/images/5"
  },
  {
    id: 6,
    text: "无无明，亦无无明尽，乃至无老死，亦无无老死尽。",
    meaning: "没有无明，也没有无明的终结；没有衰老和死亡，也没有衰老死亡的终结。",
    visualPrompt: "",
    imageUrl: "https://api.aifuture.net.cn/zenheart/images/6"
  },
  {
    id: 7,
    text: "无苦集灭道，无智亦无得，以无所得故。",
    meaning: "没有痛苦及其根源，没有痛苦的止息，也没有通往止息的路径；没有智慧，也没有所谓的获得。",
    visualPrompt: "",
    imageUrl: "https://api.aifuture.net.cn/zenheart/images/7"
  },
  {
    id: 8,
    text: "菩提萨埵，依般若波罗蜜多故，心无挂碍。",
    meaning: "菩萨依照这种超越的智慧，心中再无任何牵挂与阻碍。",
    visualPrompt: "",
    imageUrl: "https://api.aifuture.net.cn/zenheart/images/8"
  },
  {
    id: 9,
    text: "无挂碍故，无有恐怖，远离颠倒梦想，究竟涅槃。",
    meaning: "因为没有牵挂，所以没有恐惧，远离了虚妄的幻想，达到了终极的解脱。",
    visualPrompt: "",
    imageUrl: "https://api.aifuture.net.cn/zenheart/images/9"
  },
  {
    id: 10,
    text: "三世诸佛，依般若波罗蜜多故，得阿耨多罗三藐三菩提。",
    meaning: "过去、现在、未来的诸佛，都依靠这深奥的智慧，获得了无上的觉悟。",
    visualPrompt: "",
    imageUrl: "https://api.aifuture.net.cn/zenheart/images/10"
  },
  {
    id: 11,
    text: "故知般若波罗蜜多，是大神咒，是大明咒，是无上咒，是无等等咒。",
    meaning: "因此知道，这种智慧是最神圣、最明亮、最无上、最无与伦比的真言。",
    visualPrompt: "",
    imageUrl: "https://api.aifuture.net.cn/zenheart/images/11"
  },
  {
    id: 12,
    text: "能除一切苦，真实不虚。",
    meaning: "它能除掉一切痛苦，这是真实的，毫不虚妄。",
    visualPrompt: "",
    imageUrl: "https://api.aifuture.net.cn/zenheart/images/12"
  },
  {
    id: 13,
    text: "故说般若波罗蜜多咒，即说咒曰：揭谛揭谛，波罗揭谛，波罗僧揭谛，菩提萨婆诃。",
    meaning: "于是宣说此智慧咒语：去吧，去吧，去到彼岸吧，大家一起去到彼岸，觉悟吧！",
    visualPrompt: "",
    imageUrl: "https://api.aifuture.net.cn/zenheart/images/13"
  }
];

export const ZEN_MUSIC = [
  { id: 'none', name: '静音', url: '' },
  { id: 'relaxing-meditation', name: '放松冥想', url: 'https://m.xintuxiangce.top/zenheart/Relaxing%20Meditation.mp3' },
  { id: 'relaxation', name: '放松', url: 'https://m.xintuxiangce.top/zenheart/Relaxation.mp3' },
  { id: 'monastery-at-evening', name: '寺院黄昏', url: 'https://m.xintuxiangce.top/zenheart/monastery-at-evening.wav' },
  { id: 'monastery', name: '寺院', url: 'https://m.xintuxiangce.top/zenheart/Monastery.mp3' },
  { id: 'meditation-is-the-practice-of-death', name: '冥想是死亡的练习', url: 'https://m.xintuxiangce.top/zenheart/MediationIsThePracticeofDeath.mp3' },
  { id: 'fifteen-minute-meditation-timer', name: '十五分钟冥想计时器', url: 'https://m.xintuxiangce.top/zenheart/fifteen-minute-meditation-timer.mp3' },
  { id: 'ambient-relaxation', name: '环境放松', url: 'https://m.xintuxiangce.top/zenheart/AmbientRelaxation.mp3' }
];
